import React, { createContext, useContext, useEffect, useState } from "react";
import { onAuthStateChanged, signOut } from "firebase/auth";
import {auth, provider} from "../firebase/firebase-config";
import {GoogleAuthProvider, signInWithPopup} from "firebase/auth";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            setUser(user);
            setLoading(false);
        });
        return () => unsubscribe();
    }, []);

    const signInWithGoogle = async () => {
        console.log('Starting Google sign-in process...');
        try {
            console.log('Calling signInWithPopup...');
            const result = await signInWithPopup(auth, provider);
            console.log('Sign-in successful:', result);
            const user = result.user;
            const token = GoogleAuthProvider.credentialFromResult(result).accessToken;
            console.log("User Info:", user);
            console.log("Access Token:", token);
            return {user, token};
        } catch (error) {
            console.error("Error during sign-in: ", error);
            console.error("Error code:", error.code);
            console.error("Error message:", error.message);
            return {error: error.message};
        }
    };

    const logout = async () => {
        try {
            await signOut(auth);
        } catch (error) {
            console.error("Error during sign-out: ", error.message);
        }
    };

    const value = {
        user,
        loading,
        signInWithGoogle,
        logout
    };

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuthContext = () => useContext(AuthContext);
